import { Alert, AlertDescription, Box, CloseButton } from "@chakra-ui/react";
import alertTriangleIcon from "assets/img/customer/alert-triangle.svg";
interface ErrorAlertProps {
  message: string;
  icon?: boolean;
  onClose?: () => void;
  bgColor?: string;
  iconColor?: string;
}

export function ErrorAlert({ message, icon, onClose, bgColor, iconColor }: ErrorAlertProps) {
  return (
    <Alert
      status="error"
      mb="24px"
      bgColor={bgColor ?? "#FEF2F2"}
      borderRadius="8px"
      padding="12px 16px"
      justifyContent="center"
    >
      <Box width="100%" display="flex" alignItems="center" textAlign="center">
        {icon && (
          <Box
            as="span"
            w="20px"
            h="18px"
            mr="8px"
            bg={iconColor ?? "#0B0E10"}
            flexShrink={0}
            sx={{
              mask: `url(${alertTriangleIcon}) no-repeat center / contain`,
              WebkitMask: `url(${alertTriangleIcon}) no-repeat center / contain`,
            }}
          />
        )}
        <AlertDescription
          color="#0B0E10"
          fontSize="14px"
          fontFamily="General Sans"
          fontWeight="400"
          lineHeight="160%"
        >
          {message}
        </AlertDescription>
      </Box>
      {onClose && (
        <CloseButton
          position="absolute"
          right="8px"
          top="50%"
          transform="translateY(-50%)"
          color="#0B0E10"
          onClick={onClose}
        />
      )}
    </Alert>
  );
}
